(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enterprise-cart"] && !Shopify.designMode) return;
  try {
    
(() => {
  let quantityTimer;

  const submitCart = (form) => {
    if (!form) return;
    form.classList.add('is-updating');
    form.submit();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-quantity]');
    if (!button) return;
    const wrapper = button.parentElement;
    const input = wrapper.querySelector('[data-cart-quantity-input]');
    if (!input) return;
    const change = button.dataset.cartQuantity === 'plus' ? 1 : -1;
    input.value = Math.max(0, Number(input.value || 0) + change);
    clearTimeout(quantityTimer);
    quantityTimer = setTimeout(() => submitCart(button.closest('form')), 350);
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-quantity-input]');
    if (!input) return;
    input.value = Math.max(0, Number(input.value || 0));
    clearTimeout(quantityTimer);
    quantityTimer = setTimeout(() => submitCart(input.closest('form')), 350);
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-enterprise-cart-quick-add]');
    if (!button || button.dataset.busy === 'true') return;
    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    const initialText = button.textContent;
    button.dataset.busy = 'true';
    button.disabled = true;
    button.textContent = 'Wird hinzugefügt …';

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: variantId, quantity: 1}]})
      });
      if (!response.ok) throw new Error('Cart add failed');

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event: 'enterprise_cart_cross_sell_add', product_id: button.dataset.productId, variant_id: String(variantId)});
      button.textContent = 'Hinzugefügt ✓';
      setTimeout(() => window.location.reload(), 450);
    } catch (error) {
      button.textContent = 'Bitte erneut';
      button.disabled = false;
      button.dataset.busy = 'false';
      setTimeout(() => { button.textContent = initialText; }, 1800);
    }
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-enterprise-cart-rec-link]');
    if (!link) return;
    const card = link.closest('[data-enterprise-cart-rec-product]');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event: 'enterprise_cart_cross_sell_click', product_id: card ? card.dataset.enterpriseCartRecProduct : undefined});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enterprise-recovery-context"] && !Shopify.designMode) return;
  try {
    
(() => {
  const context = document.querySelector('[data-enterprise-recovery-context]');
  if (!context) return;

  const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const segment = context.dataset.segment || 'STANDARD';
  const cartItems = Number(context.dataset.cartItems || 0);
  const cartValueCents = Number(context.dataset.cartValueCents || 0);
  const b2bThreshold = Number(context.dataset.b2bThreshold || 10);
  const email1 = Number(context.dataset.email1Hours || 2);
  const email2 = Number(context.dataset.email2Hours || 24);
  const email3 = Number(context.dataset.email3Hours || 72);
  const version = context.dataset.version || 'enterprise-recovery-v1';

  const attributes = {
    'Enterprise Recovery Segment': segment,
    'Enterprise Recovery Version': version,
    'Enterprise Recovery E1': `${email1}h`,
    'Enterprise Recovery E2': `${email2}h`,
    'Enterprise Recovery E3': `${email3}h`,
    'Enterprise Recovery B2B Threshold': String(b2bThreshold)
  };

  const injectIntoCartForms = () => {
    const forms = document.querySelectorAll('form[action*="/cart"]');
    forms.forEach((form) => {
      Object.entries(attributes).forEach(([key, value]) => {
        const fieldName = `attributes[${key}]`;
        let input = Array.from(form.querySelectorAll('input[type="hidden"]')).find((node) => node.name === fieldName);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = fieldName;
          form.appendChild(input);
        }
        input.value = value;
      });
    });
  };

  const persistAttributes = async () => {
    const response = await fetch(`${shopRoot}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ attributes })
    });
    if (!response.ok) throw new Error('Enterprise recovery context could not be saved');
    return response.json();
  };

  injectIntoCartForms();

  const signature = JSON.stringify({ segment, cartItems, cartValueCents, email1, email2, email3, version });
  const signatureKey = 'enterpriseRecoveryContextSignature';
  let currentSignature = null;
  try { currentSignature = sessionStorage.getItem(signatureKey); } catch (error) {}

  if (currentSignature !== signature) {
    persistAttributes()
      .then(() => {
        try { sessionStorage.setItem(signatureKey, signature); } catch (error) {}
      })
      .catch(() => {});
  }

  window.dataLayer = window.dataLayer || [];
  const trackingKey = `enterpriseRecoveryTracked:${signature}`;
  let tracked = false;
  try { tracked = sessionStorage.getItem(trackingKey) === '1'; } catch (error) {}
  if (!tracked) {
    window.dataLayer.push({
      event: 'enterprise_recovery_eligible',
      recovery_segment: segment.toLowerCase(),
      cart_items: cartItems,
      cart_value: cartValueCents / 100,
      recovery_email_1_hours: email1,
      recovery_email_2_hours: email2,
      recovery_email_3_hours: email3
    });
    try { sessionStorage.setItem(trackingKey, '1'); } catch (error) {}
  }

  document.addEventListener('click', (event) => {
    const checkout = event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
    if (!checkout) return;

    injectIntoCartForms();
    persistAttributes().catch(() => {});

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'enterprise_checkout_started',
      recovery_segment: segment.toLowerCase(),
      cart_items: cartItems,
      cart_value: cartValueCents / 100
    });
  }, { capture: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enterprise-smart-cross-sell"]) return;
  try {
    
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-enterprise-quick-add]');
  if (!button || button.dataset.busy === 'true') return;
  const variantId = Number(button.dataset.variantId);
  if (!variantId) return;
  const originalText = button.textContent;
  button.dataset.busy = 'true';
  button.disabled = true;
  button.textContent = 'Wird hinzugefügt …';
  try {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const response = await fetch(`${root}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1}]})});
    if (!response.ok) throw new Error('Cart add failed');
    button.textContent = 'Hinzugefügt ✓';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event:'enterprise_cross_sell_add',product_id:button.dataset.productId,variant_id:String(variantId)});
    document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{source:'enterprise-cross-sell'}}));
    setTimeout(()=>{button.textContent=originalText;button.disabled=false;button.dataset.busy='false';},1800);
  } catch (error) {
    button.textContent = 'Bitte erneut';
    button.disabled = false;
    button.dataset.busy = 'false';
    setTimeout(()=>{button.textContent=originalText;},1800);
  }
});
document.addEventListener('click',(event)=>{const link=event.target.closest('[data-enterprise-rec-link]');if(!link)return;const card=link.closest('[data-enterprise-rec-product]');window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'enterprise_cross_sell_click',product_id:card?card.dataset.enterpriseRecProduct:undefined});});

  } catch(e) { console.error(e); }
})();
})();
